import { isOnlyWhitespace } from '../../services/dom/elementEmptyService';
import { isCodeBlockElement } from '../dom/codeBlock';
import { isEmbeddedContent } from '../dom/content';
import { isListItemElement } from '../dom/list';
import { isText } from '../dom/node';
import { isTableCellElement } from '../dom/table';
import { isBlockquoteElement } from '../quote';

export const computeIsElementEmpty = (document: Document, element: Element) => {
  const iterator = document.createNodeIterator(element, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, {
    acceptNode: node => {
      if (isText(node)) {
        return isOnlyWhitespace(node.data) ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
      }

      // Block quotes, lists, tables, and code blocks are visible even when they have no content.
      if (
        isEmbeddedContent(node) ||
        isBlockquoteElement(node) ||
        isListItemElement(node) ||
        isTableCellElement(node) ||
        isCodeBlockElement(node)
      ) {
        return NodeFilter.FILTER_ACCEPT;
      }

      return NodeFilter.FILTER_SKIP;
    },
  });

  return !iterator.nextNode();
};
